// eslint-disable-next-line import/prefer-default-export
export const throwErrorWithData = (message, data) => {
  const error = new Error(message);
  error.data = data;
  throw error;
};
